export const limited_identifier = {
  period: 'period',
  quantity: 'quantity',
  max_purchase_per_user: 'max_purchase_per_user',
} as const;

export const findByLimitedIdentifier = (
  id: keyof typeof limited_identifier,
): keyof typeof limited_identifier => {
  return limited_identifier[id];
};
